import React, { Component, Fragment } from "react";
import { CurrencyUtils, Alert } from "../../utils";
import CloseTab from "../../images/close.svg";
import "./coverDetail.scss";
const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

export default class CoverDetailsModalComponent extends Component {
  // state = {
  //   coverDetails: []
  // };
  constructor(props) {
    super(props);
  
  }

  renderLoading() {
    const { show } = this.props;
    return (
      <Modal show={show} handleClose={this.props.hideModal}>
        <div className="form-wrapper">{Alert.showLoading()}</div>
      </Modal>
    );
  }

  renderCloseLoading() {
    const { show } = this.props;
    return (
      <Modal show={show} handleClose={this.props.hideModal}>
        <div className="form-wrapper">{Alert.hideLoading()}</div>
      </Modal>
    );
  }


  renderCoverDetail() {
    const {
      show,
      listItem,
      selectedPackage,
      insurance_type,
      coverDetails
    } = this.props;

    const item = listItem.filter(listItem => listItem.id === selectedPackage) || {};
    let packCode = "";
    let detail = "";

    const isNumber = (n) => { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); } 

    return (
      <Modal show={show} handleClose={this.props.hideModal}>
        <div className="form-wrapper">
          <div className="form-group title mb-0">
            {item &&
              Object.keys(item).map(function(key) {
                packCode = item[key].packageCode;
                const productName = item[key].product_name;
                const name = item[key].name;
                detail =
                  coverDetails.filter(
                    coverDetails => coverDetails.package_code === packCode
                  ) || {};
                return (
                  <Fragment>
                    <label className="text-blue ml-auto mt-2 font-bold">
                      {insurance_type} {item[key].title} ทุนประกัน{" "}
                      {CurrencyUtils.commaFormat(parseInt(item[key].insured))}{" "}
                      บาท
                    </label>
                    {
                       productName && name &&
                       <p className="mt-3 mb-0">{productName} {name}</p>
                    }
                  </Fragment>
                );
              })}
          </div>

          {detail &&
            Object.keys(detail).map(function(key) {
              return (
                <Fragment>
                  {detail[key].coverage_name && detail[key].insured ? (
                    <div className="form-group paragraph mb-0">
                      <label className="ml-auto mt-3">
                        {detail[key].coverage_name}
                      </label>
                      <br />{" "}
                      <span className="ml-auto mt-3">
                        { isNumber(detail[key].insured) ? 
                          CurrencyUtils.commaFormat(parseInt(detail[key].insured))
                          : detail[key].insured
                        }
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </Fragment>
              );
            })}
        </div>
      </Modal>
    );
  }

  render() {
    // const { coverDetails } = this.state;
    const {
      coverDetails,
      show
    } = this.props;

    return (
      <Fragment>
        {show && coverDetails && coverDetails.length === 0
          ? this.renderLoading()
          : this.renderCloseLoading() && this.renderCoverDetail()}
      </Fragment>
    );
  }
}

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="form-group modal-header mb-0">
          <div className="header control-label col-sm-3">
            <label>รายละเอียดความคุ้มครอง</label>
          </div>
          <div className="header ml-auto" onClick={handleClose}>
            <Icon className="ml-auto" src={CloseTab} />
          </div>
        </div>
        {children}
      </section>
    </div>
  );
};
